export default __webpack_public_path__ + "static/media/subscription_header.ea04a268.svg";